module.exports = __webpack_public_path__ + "static/3-85ecfc00b3360e02e004fb5783bb1ac6.png";